import { render } from "./SobreNos.vue?vue&type=template&id=5024cefd&scoped=true"
import script from "./SobreNos.vue?vue&type=script&lang=js"
export * from "./SobreNos.vue?vue&type=script&lang=js"

import "./SobreNos.vue?vue&type=style&index=0&id=5024cefd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5024cefd"]])

export default __exports__